import React, { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import classNames from 'classnames';

import { PostService } from '../../../entities/providers/types';
import { actions as ratesActs, StepType } from '../../../entities/rates';

import * as acts from '../../../entities/providers/actions';
import * as providerSelectors from '../../../entities/providers/selectors';

import { Layout } from '../../element';

import { Price } from '../../providers/parcel-price';

import { Image } from '../../image';
import { ServiceItem, Title, Description } from './styled';

import { useTranslation } from '../../../i18n';

export const RatesServices: React.FC<{ disabled?: boolean }> = ({ disabled = false }) => {
  const [t] = useTranslation('rates');

  const dispatch = useDispatch();

  const provider = useSelector(providerSelectors.getActiveDeliver);
  const services = useSelector(providerSelectors.getDeliversServices);

  const handleBook = useCallback(
    (service: PostService) => () => {
      dispatch(ratesActs.setStep({ step: StepType.form }));
      dispatch(acts.bookService({ service }));
    },
    []
  );

  return (
    <>
      {services.map((service) => (
        <ServiceItem key={service.type}>
          <Layout.Row gutter={20}>
            <Layout.Col span={24} xs={12} sm={12} md={6} lg={6}>
              <Image src={provider.logo} />
            </Layout.Col>
            <Layout.Col span={24} xs={12} sm={12} md={10} lg={10}>
              <Title>{service.description}</Title>
              <Description>{service.info}</Description>
              <Description>{service.info1}</Description>
              <Description>{service.info2}</Description>
            </Layout.Col>
            <Layout.Col span={24} xs={24} sm={24} md={8} lg={8}>
              <button
                type="button"
                className={classNames('el-button el-button--primary is-plain mb-10 full-width', {
                  'is-disabled': disabled,
                })}
                disabled={disabled}
                id={service.analytics.bookID}
                onClick={handleBook(service)}
              >
                <span>{t('rates.services.book')}</span>
              </button>

              <Price price={service.price} priceDiscount={service.price_discount} discount={service.discount || null}>
                {t('rates.services.from')}
              </Price>
            </Layout.Col>
          </Layout.Row>
        </ServiceItem>
      ))}
    </>
  );
};
